import request from '@/utils/request'

//上传图片
export function obsUploadImage(formData) {
    return request.post('file/obsUploadImage', formData)
}
//上传文件
export function obsUploadFile(formData) {
    return request.post('/file/obsUploadFile', formData)
}
//身份证信息验证
export function identifyIDCard(memberFIDCardImg, memberIDCard, memberName) {
    return request.post('/identify/identifyIDCard?memberFIDCardImg=' + memberFIDCardImg + '&memberIDCard=' + memberIDCard + '&memberName=' + memberName)
}
//营业执照信息验证
export function identifyLicense(LicenseImg, companyCode, companyName, legalName) {
    return request.post('/identify/identifyLicense?LicenseImg=' + LicenseImg + '&companyCode=' + companyCode + '&companyName=' + companyName + '&legalName=' + legalName)
}